import React from 'react'
import style from "./Loader.module.css"
const Loader = () => {
  return (
    <div>
      <div className={style.container}>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
  <div className={style.particle}></div>
</div>



    </div>
  )
}

export default Loader
